// extracted by mini-css-extract-plugin
export default {"outer":"Home_outer__iEvt9","headline":"Home_headline__5RAL9","member":"Home_member__qtNpS","flash":"Home_flash__kkqGI","bottom_text":"Home_bottom_text__II+M7"};